<style>
    .c-color .vc-slider{
        width: 100%;
    }

    .c-color .sketch-compact {
        box-shadow:none;
        padding: 0px;
    }

    .c-color .vc-sketch-saturation-wrap {
        padding:0px;
        padding-bottom: 0px;
        height: 50px;
    }

    .c-color .sketch-compact .vc-sketch-alpha-wrap, .c-color .sketch-compact .vc-sketch-presets, .c-color .sketch-compact .vc-sketch-color-wrap {
        display:none;
    }
</style>

<template>
    <b-form-group
            class="c-color"
            :description="description"
            :label="label"
            :label-for="id"
            :label-cols="labelCols"
            :aria-describedby="id + '_InvalidFeedback'">
        <Slider v-if="mode === 'slider'" v-model="dataValue" />
        <Sketch v-if="mode === 'sketch'" v-model="dataValue" />
        <Sketch class="sketch-compact" v-if="mode === 'sketchCompact'" v-model="dataValue" />
      <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
        {{invalidFeedbackMessage}}
      </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
    import { Slider, Sketch } from 'vue-color'
  export default {
      name: 'InputColor',
      components: {
          Slider,
          Sketch
      },
      props: {
          mode: {
              type: String,
              default: 'slider'
          },
          required: {
              type: Boolean,
              default: false
          },
          value: {
              type: Object,
              default: function() {
                  return {}
              }
          },
          id: {
              type: String,
              default: ''
          },
          label: {
              type: String,
              default: ''
          },
          description: {
              type: String,
              default: ''
          },
          labelCols: {
              type: Number,
              default: 0
          },
          readOnly: {
              type: Boolean,
              default: false
          },
          invalidFeedbackMessage: {
              type: String,
              default: ''
          },
          form: {
              type: Object,
              default: function() {return {}}
          }
      },
      watch: {
          value(val) {
              this.dataValue = val
          },
          dataValue(val) {
              this.$emit('input', val)
          }
      },
      mounted() {
          this.dataValue = this.value
      },
      data: () => {
          return {
              dataValue: ''
          }
      },
      methods: {
          chkState(val) {
              if (this.form !== undefined && this.form[val] !== undefined) {
                  const field = this.form[val]
                  return !field.$dirty || !field.$invalid
              }
          }
      }
  }
</script>